import { render, staticRenderFns } from "./thirdPersonLists.vue?vue&type=template&id=4f941ee2&scoped=true&"
import script from "./thirdPersonLists.vue?vue&type=script&lang=js&"
export * from "./thirdPersonLists.vue?vue&type=script&lang=js&"
import style0 from "./thirdPersonLists.vue?vue&type=style&index=0&id=4f941ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f941ee2",
  null
  
)

export default component.exports